import { segmentInitScript } from '@/plugins/segment/SegmentInitScript'

export class SegmentClient {
  static DEFAULT_SEGMENT_VERSION = '4.15.2'

  #persistentProperties = {
    track: {},
    page: {},
    identify: {},
    group: {}
  }

  #options = {
    track: {},
    page: {},
    identify: {},
    group: {}
  }

  #tempSegment

  constructor (writeKey, persistentProperties, options, version = SegmentClient.DEFAULT_SEGMENT_VERSION) {
    if (writeKey) {
      persistentProperties && Object.keys(this.#persistentProperties).forEach(key => {
        this.#persistentProperties[key] = persistentProperties[key] || {}
      })
      options && Object.keys(this.#options).forEach(key => {
        this.#options[key] = options[key] || {}
      })
      this.#tempSegment = segmentInitScript(writeKey, version)
    } else {
      throw new Error('Segment write key not provided')
    }
  }

  get segment () {
    if (window.analytics?.initialized) {
      this.#tempSegment = undefined
      return window.analytics
    }
    if (this.#tempSegment) {
      return this.#tempSegment
    }
    throw new Error('Segment not initialized')
  }

  async gatherProperties (properties) {
    try {
      if (typeof properties === 'object') {
        return properties
      } else if (typeof properties === 'function') {
        return await properties()
      }
    } catch (e) {
      console.error('Segment : could not process properties', e)
    }
    return {}
  }

  async track (eventName, additionalProperties = {}) {
    const properties = await Object.assign(
      await this.gatherProperties(this.#persistentProperties.track),
      await this.gatherProperties(additionalProperties)
    )
    const options = await this.gatherProperties(this.#options.track)
    this.segment.track(eventName, this._transform(properties), options)
  }

  async page (pageName, additionalProperties = {}) {
    const properties = await Object.assign(
      await this.gatherProperties(this.#persistentProperties.page),
      await this.gatherProperties(additionalProperties)
    )
    const options = await this.gatherProperties(this.#options.page)
    this.segment.page(undefined, pageName, this._transform(properties), options)
  }

  async identify (userId, additionalProperties = {}) {
    const properties = await Object.assign(
      await this.gatherProperties(this.#persistentProperties.identify),
      await this.gatherProperties(additionalProperties)
    )
    const options = await this.gatherProperties(this.#options.identify)
    this.segment.identify(userId, this._transform(properties), options)
  }

  async group (groupId, additionalProperties = {}) {
    const properties = await Object.assign(
      await this.gatherProperties(this.#persistentProperties.group),
      await this.gatherProperties(additionalProperties)
    )
    const options = await this.gatherProperties(this.#options.group)
    this.segment.group(groupId, this._transform(properties), options)
  }

  _transform (data) {
    if (data && typeof data === 'object' && !Array.isArray(data)) {
      Object.entries(data).forEach(([key, value]) => {
        delete data[key]
        data[key.replace(/([A-Z])/g, '_$1').toLowerCase()] = this._transform(value)
      })
      return data
    } else if (data && Array.isArray(data) && data.length) {
      return data.map(item => this._transform(item))
    } else if (typeof data !== 'undefined') {
      return data
    }
    return null
  }
}
